import React from "react";
import { useQuestionsWS } from "../lib/useQuestionsWS";

/**
 * Broadcast-style "lower-third" graphic overlay. Pinned bottom-left of every
 * page. Slides in from the left with a 3D rotateY entrance whenever an admin
 * features a question. Designed to feel like a real stream production card.
 */
export const QAOverlay = () => {
    const { featured } = useQuestionsWS();
    const active = !!featured;
    return (
        <div
            data-testid="qa-overlay"
            className="fixed bottom-6 left-4 sm:bottom-10 sm:left-10 z-[60] pointer-events-none"
            style={{ perspective: "1000px" }}
            aria-live="polite"
        >
            <div
                className={`flex flex-col gap-1.5 px-6 sm:px-8 py-4 sm:py-5 border-l-[6px] border-l-amber-400 shadow-[0_20px_40px_rgba(0,0,0,0.55)] min-w-[280px] sm:min-w-[360px] max-w-[92vw] sm:max-w-[600px] rounded-r-xl will-change-transform transition-all duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)]`}
                style={{
                    background:
                        "linear-gradient(135deg, rgba(20,20,20,0.96) 0%, rgba(5,5,5,0.96) 100%)",
                    transform: active
                        ? "translateX(0) rotateY(0deg)"
                        : "translateX(-120%) rotateY(-15deg)",
                    opacity: active ? 1 : 0,
                    transitionProperty: "transform, opacity",
                }}
            >
                <div className="flex items-center gap-2">
                    <span
                        className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"
                        aria-hidden
                    />
                    <span
                        className="font-anton uppercase tracking-[3px] text-[11px] sm:text-xs font-extrabold text-amber-400"
                        data-testid="qa-overlay-meta"
                    >
                        Hot Seat · Q&A
                        {featured ? ` · From @${featured.username}` : ""}
                    </span>
                </div>
                <p
                    data-testid="qa-overlay-text"
                    className="font-chivo font-medium text-base sm:text-lg leading-snug text-white"
                >
                    {featured ? featured.text : "Question UI Text Content goes here."}
                </p>
                {featured && featured.votes > 0 && (
                    <div className="font-anton uppercase tracking-[3px] text-[10px] text-amber-400/70 mt-1">
                        ↑ {featured.votes} upvote{featured.votes === 1 ? "" : "s"}
                    </div>
                )}
            </div>
        </div>
    );
};
